import * as React from 'react';
import { AppNavLink } from 'src/models/Utility/AppNavLink';
import { SidebarLayout } from '../utility/components/SidebarLayout';

const DataNavLinks: AppNavLink[] = [
    { text: "Index", path: "/data" },
    { text: "DS Sourcebooks", path: "/data/draw-steel-sourcebooks" }
];

export function DataManager(): JSX.Element {
    return (
        <SidebarLayout links={DataNavLinks} />
    );
}
